module.exports = Object.freeze({
  FRONT: "user",
  REAR: "environment",
});
